const routes = [
  {
    path: 'async',
    name: 'async',
    component: () => import(/* webpackChunkName: "async" */ '@/modules/async/index.vue')
  },
];

export default routes;